import { useDispatch, useSelector } from 'react-redux';
import './App.css';
import MainRoute from './MainRoute';
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { FaWhatsapp } from "react-icons/fa";
import { useEffect } from 'react';
import { createWeek } from './hooks/week';

function App() {
// const isDarkMode = useSelector((state) => state.theme.isDarkMode);
  const phoneNumber = "+201000943383"; // Replace with the actual phone number
  const message = "Hello, I need help!"; // Default message
const dispatch=useDispatch()
  const openWhatsApp = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };
  // 
// useEffect(() => {
//     const handleContextmenu = (e) => {
//       e.preventDefault(); // يمنع ظهور القائمة عند الضغط كليك يمين
//     };
//     document.addEventListener('contextmenu', handleContextmenu);
//     return () => {
//       document.removeEventListener('contextmenu', handleContextmenu);
//     };
//   }, []);

useEffect(() => {
  const today = new Date();
const todaydata = new Date().toISOString()?.split("T")[0];

console.log(today);
  if (today.getDay() === 6) {
    dispatch(createWeek(todaydata));
  }
}, []);
  return (
<div className={ "ar_app"}>
      <MainRoute />
      <ToastContainer />
{/* 
      <button
        onClick={openWhatsApp}
        style={{
          position: "fixed",
          bottom: "20px",
left:  "20px",

          backgroundColor: "#25D366",
          color: "white",
          border: "none",
          borderRadius: "50%",
          fontSize: "18px",
          cursor: "pointer",
          width: 50,
          height:50,
          boxShadow: "2px 2px 10px rgba(0,0,0,0.3)",
          zIndex:10000000000
        }}
      >
        <FaWhatsapp 
        size={30}
        />

      </button> */}
    </div>

  );
}

export default App;
